// src/modules/clinical-notes-v2/components/TemplateSelector.jsx
//
// Selector visual de los 4 templates de notas clínicas. Maneja los
// strings AdvancedMD (ej. "Hospital Discharge Follow Up"); el mapeo al
// nombre AI ("Hospital Discharge FU") lo hace el service.

import React from "react";
import { Box, Paper, Stack, Typography, ToggleButton, ToggleButtonGroup } from "@mui/material";

import EventNoteIcon       from "@mui/icons-material/EventNote";
import LocalHospitalIcon   from "@mui/icons-material/LocalHospital";
import HealthAndSafetyIcon from "@mui/icons-material/HealthAndSafety";
import VideoCallIcon       from "@mui/icons-material/VideoCall";

export const TEMPLATES = [
  {
    advmdName: "Follow Up Exam 2.0",
    label: "Follow Up Exam",
    icon: <EventNoteIcon fontSize="small" />,
    reasonDefault: "Follow up visit",
  },
  {
    advmdName: "Hospital Discharge Follow Up",
    label: "Hospital Discharge FU",
    icon: <LocalHospitalIcon fontSize="small" />,
    reasonDefault: "NP ER Discharge FU",
  },
  {
    advmdName: "Annual Wellness 2.0",
    label: "Annual Wellness",
    icon: <HealthAndSafetyIcon fontSize="small" />,
    reasonDefault: "Annual Wellness Visit",
  },
  {
    advmdName: "Telehealth Visit 2.0",
    label: "Telehealth",
    icon: <VideoCallIcon fontSize="small" />,
    reasonDefault: "Telehealth Visit",
  },
];

export default function TemplateSelector({ value, onChange, disabled = false }) {
  return (
    <Paper variant="outlined" sx={{ p: 2, borderRadius: 2 }}>
      <Typography variant="overline" color="text.secondary">
        Note Template
      </Typography>
      <Box sx={{ mt: 1 }}>
        <ToggleButtonGroup
          value={value}
          exclusive
          onChange={(_, next) => next && onChange(next)}
          disabled={disabled}
          size="small"
          sx={{
            flexWrap: "wrap",
            gap: 1,
            "& .MuiToggleButton-root": {
              border: "1px solid",
              borderColor: "divider",
              borderRadius: 2,
              textTransform: "none",
              fontWeight: 600,
              px: 1.5,
              py: 0.75,
            },
            "& .Mui-selected": {
              bgcolor: "primary.main",
              color: "primary.contrastText",
              "&:hover": { bgcolor: "primary.dark" },
            },
          }}
        >
          {TEMPLATES.map((t) => (
            <ToggleButton key={t.advmdName} value={t.advmdName}>
              <Stack direction="row" alignItems="center" spacing={0.75}>
                {t.icon}
                <span>{t.label}</span>
              </Stack>
            </ToggleButton>
          ))}
        </ToggleButtonGroup>
      </Box>
    </Paper>
  );
}
